import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <Link to="/" className="flex items-center gap-3 group">
            <img
              src="https://static.readdy.ai/image/9e0ec1f08df5eac0f8e6ee60a23adb36/71c80160d04a459cf0ff28e8673272c6.png"
              alt="Tello Crafts - Two hands creating a home"
              className="h-12 w-auto transition-transform group-hover:scale-105"
            />
            <div className="hidden sm:block">
              <div className="text-sm font-bold text-gray-900">Tello Crafts</div>
              <div className="text-xs text-gray-600 flex items-center gap-1">
                <i className="ri-hand-heart-line text-amber-600"></i>
                Handmade with Love
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#home"
              className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Home
            </a>
            <a
              href="#products"
              className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Collections
            </a>
            <a
              href="#gallery"
              className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Gallery
            </a>
            <a
              href="#about"
              className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Our Story
            </a>
            <a
              href="#contact"
              className="bg-amber-600 text-white px-6 py-2.5 rounded-full text-sm font-semibold hover:bg-amber-700 transition-all shadow-md hover:shadow-lg whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              <i className="ri-home-smile-line"></i>
              Get in Touch
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-lg cursor-pointer text-gray-700"
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-gray-200">
          <div className="px-4 py-4 space-y-3">
            <a
              href="#home"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-sm font-medium text-gray-700 hover:text-amber-600 cursor-pointer"
            >
              Home
            </a>
            <a
              href="#products"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-sm font-medium text-gray-700 hover:text-amber-600 cursor-pointer"
            >
              Collections
            </a>
            <a
              href="#gallery"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-sm font-medium text-gray-700 hover:text-amber-600 cursor-pointer"
            >
              Gallery
            </a>
            <a
              href="#about"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block text-sm font-medium text-gray-700 hover:text-amber-600 cursor-pointer"
            >
              Our Story
            </a>
            <a
              href="#contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="block bg-amber-600 text-white px-6 py-2.5 rounded-full text-sm font-semibold text-center cursor-pointer"
            >
              Get in Touch
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
